export function fixSafariNavWidth() {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (!isSafari) return;

  const subNavs = document.querySelectorAll('.main-nav__sub-navigation');

  subNavs.forEach(function(subNav) {
    const childList = subNav.querySelector('.main-nav__child-list');
    if (!childList) return;

    const wasHidden = getComputedStyle(subNav).display === 'none';
    const prevDisplay = subNav.style.display;
    const prevVisibility = subNav.style.visibility;

    if (wasHidden) {
      subNav.style.visibility = 'hidden';
      subNav.style.display = 'block';
    }
    // Reset widths to allow for accurate measurement
    subNav.style.width = '';
    childList.style.width = '';

    // Force reflow before measurement
    // eslint-disable-next-line no-unused-expressions
    childList.offsetHeight;

    const requiredWidth = Math.ceil(childList.scrollWidth);
    if (requiredWidth > 0) {
      subNav.style.width = requiredWidth + 'px';
      childList.style.width = requiredWidth + 'px';
    }

    if (wasHidden) {
      subNav.style.display = prevDisplay || '';
      subNav.style.visibility = prevVisibility || '';
    }
  });
}

export function initNavigationDropdownWidthFix() {
  window.addEventListener('load', fixSafariNavWidth);
  window.addEventListener('resize', fixSafariNavWidth);

  document.addEventListener('click', function(event) {
    const toggle = event.target.closest('[data-nav-toggle]');
    if (!toggle) return;

    const item = toggle.closest('.main-nav__item');
    if (!item) return;

    const isOpen = item.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    fixSafariNavWidth();
  });
}
